"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRipple = void 0;
var createRipple = function (event) {
    var target = event.currentTarget;
    if (!target.classList.contains('ripple-effect'))
        return;
    var circle = document.createElement('span');
    var diameter = Math.max(target.clientWidth, target.clientHeight);
    var radius = diameter / 2;
    circle.classList.add('ripple');
    circle.style.width = circle.style.height = "".concat(diameter, "px");
    circle.style.left = "".concat(event.clientX - (target.getBoundingClientRect().left + radius), "px");
    circle.style.top = "".concat(event.clientY - (target.getBoundingClientRect().top + radius), "px");
    var existingRipple = target.querySelector('.ripple');
    if (existingRipple)
        existingRipple.remove();
    target.appendChild(circle);
};
exports.createRipple = createRipple;
